/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversioneDTO
 */
export interface ConversioneDTO {
    /**
     * 
     * @type {number}
     * @memberof ConversioneDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversioneDTO
     */
    idFiliera: number;
    /**
     * 
     * @type {string}
     * @memberof ConversioneDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConversioneDTO
     */
    idAllevatore?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ConversioneDTO
     */
    inizioValidita?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ConversioneDTO
     */
    fineValidita?: Date;
    /**
     * 
     * @type {number}
     * @memberof ConversioneDTO
     */
    valore?: number;
}

/**
 * Check if a given object implements the ConversioneDTO interface.
 */
export function instanceOfConversioneDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idFiliera" in value;

    return isInstance;
}

export function ConversioneDTOFromJSON(json: any): ConversioneDTO {
    return ConversioneDTOFromJSONTyped(json, false);
}

export function ConversioneDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversioneDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idFiliera': json['idFiliera'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'idAllevatore': !exists(json, 'idAllevatore') ? undefined : json['idAllevatore'],
        'inizioValidita': !exists(json, 'inizioValidita') ? undefined : (new Date(json['inizioValidita'])),
        'fineValidita': !exists(json, 'fineValidita') ? undefined : (new Date(json['fineValidita'])),
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
    };
}

export function ConversioneDTOToJSON(value?: ConversioneDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idFiliera': value.idFiliera,
        'descrizione': value.descrizione,
        'idAllevatore': value.idAllevatore,
        'inizioValidita': value.inizioValidita === undefined ? undefined : (value.inizioValidita.toISOString()),
        'fineValidita': value.fineValidita === undefined ? undefined : (value.fineValidita.toISOString()),
        'valore': value.valore,
    };
}

